// WARNING: Do NOT edit this file outside npm-helsecore, it will be reset on build!

import React from 'react';
import { ArticleBody } from '@dip/helsecore/src/components/parts/ArticleBody/ArticleBody';
import type { ArticleBodyProps } from '@dip/helsecore/src/components/parts/ArticleBody/ArticleBody.d';

export default (props: Readonly<ArticleBodyProps>) => <ArticleBody {...props} />
